

export class incidencia{
	
    public id :number
	public titulo:String
	public estatus:String
	public nomtester:String
	public nomdesarrollador:String
	public prioridad:String
	public fecha_creacion:String
	public fecha_actualizacion:String
	public id_usuario_autor:number
	public id_usuario_desarrollo:number
	public id_usuario_qa:number
	public id_proyecto:number
	public id_incidencia_proyecto:number
	public id_incidencia_cliente:number
	public incidenciasXEstatus:String
	public incidenciasXEstatusCu:String
	public esComentario:number
	public id_ciclo:number
	public color:String
	public imgEstatus:String
	public  seleccionada:boolean
	public  nombreTarea:String
	public  id_tarea:number
	public  tareasAsociadas: Array<any>
	public  fechaInicio:String
	public  fechaFin:String
	public  numI:number
	public  id_etapa:number
	public  archivos:Array<File>
	public	descripcion_incidencia: string;
}